import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Icon } from '../../../../../../base/components/Icon';
import ListSubheader from '@mui/material/ListSubheader/ListSubheader';
import { __t } from '../../../../../../base/utils/t';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { responsesActions } from '../../../redux/slices/responsesSlice';
import { VacancyItem } from '../../../api/interfaces';

import './styles.scss';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';

interface Props {
    className?: string;
}

// Fix for translations to be fetched
// eslint-disable-next-line @typescript-eslint/no-empty-function
(() => {})();

export const VacancyItemAll: VacancyItem = {
    id: -1,
    name: __t('Всі вакансії'),
};

export const VacancySelect = ({ className = '' }: Props) => {
    const dispatch = useAppDispatch();
    const {
        vacancySelectOptions,
        filters: { vacancyId },
    } = useAppSelector((state) => state.employerResponses);
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (!vacancySelectOptions.length) {
            return;
        }
        const paramsVacancyId = searchParams.get('vacancy');
        if (paramsVacancyId) {
            dispatch(responsesActions.setFiltersVacancy(Number(paramsVacancyId)));
        }
    }, [searchParams, vacancySelectOptions]);

    const handleChange = (event: SelectChangeEvent<number>) => {
        dispatch(responsesActions.setFiltersVacancy(event.target.value as number));
    };

    const clearFilter = () => {
        dispatch(responsesActions.setFiltersVacancy(VacancyItemAll.id));
    };

    const closeHandler = () => {
        setTimeout(() => {
            const element = document.activeElement as HTMLElement;
            element?.blur();
        }, 0);
    };

    const activeVacancies = vacancySelectOptions
        .filter((i) => i.isActive)
        .map(({ id, name }) => (
            <MenuItem className='responses-filters-select__item' value={id} key={id}>
                <span className='responses-filters-select__text' title={name}>
                    {name}
                </span>
                <span className='responses-filters-select__additional-text'>
                    <span className='responses-filters-select__additional-text-separator'>·</span>
                    {__t('ID')}:{id}
                </span>
            </MenuItem>
        ));

    const closedVacancies = vacancySelectOptions
        .filter((i) => !i.isActive)
        .map(({ id, name }) => (
            <MenuItem className='responses-filters-select__item' value={id} key={id}>
                <span className='responses-filters-select__text' title={name}>
                    {name}
                </span>
                <span className='responses-filters-select__additional-text'>
                    <span className='responses-filters-select__additional-text-separator'>·</span>
                    {__t('ID')}:{id}
                </span>
            </MenuItem>
        ));

    return (
        <div className='responses-filters-select-relative-wrap'>
            <Select
                className={`responses-filters-select ${className}`}
                value={vacancyId}
                onChange={handleChange}
                onClose={closeHandler}
                variant='standard'
                disableUnderline
                MenuProps={{
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    },
                    classes: { paper: 'responses-filters-select__dropdown', list: 'responses-filters-select__list' },
                }}
                IconComponent={(props) => <Icon icon='chevron-down-regular' size='14px' {...props} />}
                renderValue={(value: number) => {
                    if (value === VacancyItemAll.id) {
                        return VacancyItemAll.name;
                    }

                    const renderValue = vacancySelectOptions.find((v) => v.id === vacancyId)?.name;

                    return (
                        <div className='responses-filters-select__render-value' title={renderValue}>
                            {renderValue}
                        </div>
                    );
                }}
            >
                <MenuItem
                    className='responses-filters-select__item responses-filters-select__item--hidden'
                    value={VacancyItemAll.id}
                >
                    {VacancyItemAll.name}
                </MenuItem>
                {activeVacancies.length && (
                    <ListSubheader className='responses-filters-select__subheader responses-filters-select__subheader--highlighted'>
                        {__t('Відкриті вакансії')}
                    </ListSubheader>
                )}
                {activeVacancies}
                {closedVacancies.length && (
                    <ListSubheader className='responses-filters-select__subheader'>
                        {__t('Закриті вакансії')}
                    </ListSubheader>
                )}
                {closedVacancies}
            </Select>
            {vacancyId !== VacancyItemAll.id && (
                <div onClick={clearFilter} className='responses-filters-select__clear-filter-button'>
                    <Icon icon='xmark-regular' size='14px' />
                </div>
            )}
        </div>
    );
};
